
import { FirearmAssignmentLogTypeInfoBase } from './firearm-assignment-log.typeinfo.base';


export class FirearmAssignmentLogTypeInfo extends FirearmAssignmentLogTypeInfoBase {
  name = 'Firearm Asset Assignment Log';
}

export const FIREARM_ASSIGNMENT_LOG_TYPE: FirearmAssignmentLogTypeInfo = new FirearmAssignmentLogTypeInfo();



